import { useCallback, useEffect, useRef, useState } from 'react'

export function useSessionTimer(autoStart = true) {
  const [elapsedSeconds, setElapsedSeconds] = useState(0)
  const [isPaused, setIsPaused] = useState(!autoStart)
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  const clearTimerInterval = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }, [])

  const startTimerInterval = useCallback(() => {
    clearTimerInterval()
    intervalRef.current = setInterval(() => {
      setElapsedSeconds((prev) => prev + 1)
    }, 1000)
  }, [clearTimerInterval])

  useEffect(() => {
    if (!isPaused) {
      startTimerInterval()
    } else {
      clearTimerInterval()
    }
    return clearTimerInterval
  }, [isPaused, startTimerInterval, clearTimerInterval])

  const reset = useCallback(() => {
    setElapsedSeconds(0)
    if (!isPaused) {
      startTimerInterval()
    }
  }, [isPaused, startTimerInterval])

  const pause = useCallback(() => setIsPaused(true), [])
  const resume = useCallback(() => setIsPaused(false), [])

  return { elapsedSeconds, reset, pause, resume, isPaused }
}
